import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { NavbarComponent } from './components/navbar/navbar.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { CustomizerComponent } from './components/customizer/customizer.component';
import { ToggleFullscreenDirective } from './directives/toggle-fullscreen.directive';
import { UserHintComponent } from './components/user-hint/user-hint.component';
import { DataLoaderComponent } from './components/data-loader/data-loader.component';
import { NoSanitizePipe } from './pipes/no-sanitize.pipe';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { DataGridComponent } from './components/data-grid/data-grid.component';
import { DataGridFilterComponent } from './components/data-grid-filter/data-grid-filter.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErrorComponent } from './components/error/error.component';
import { SiteHeaderComponent } from './components/site-header/site-header.component';
import { SiteFooterComponent } from './components/site-footer/site-footer.component';
import { DocumentListComponent } from './components/document-list/document-list.component';
import { DocumentSingleComponent } from './components/document-single/document-single.component';
import { SiteVpSelectorComponent } from './components/site-vp-selector/site-vp-selector.component';
import { SiteBreadcrumbsComponent } from './components/site-breadcrumbs/site-breadcrumbs.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { PermissionHideDirective } from './directives/permission-hide.directive';
import { SiteFileuploadComponent } from './components/site-fileupload/site-fileupload.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { DateDeclensionPipe } from './pipes/date-declension.pipe';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { TextHighlightPipe } from './pipes/text-highlight.pipe';
import { StripHtmlTagsPipe } from './pipes/strip-html-tags.pipe';
import { NgbAlertModule, NgbCollapseModule, NgbDropdownModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AdminFooterComponent } from './components/admin-footer/admin-footer.component';
import { MatSelectModule } from '@angular/material/select';
// import { DeviceDetectorModule } from 'ngx-device-detector';


@NgModule({
    exports: [
      CommonModule,
      NavbarComponent,
      SidebarComponent,
      CustomizerComponent,
      ToggleFullscreenDirective,
      TranslateModule,
      UserHintComponent,
      DataLoaderComponent,
      NoSanitizePipe,
      PaginatorComponent,
      DataGridComponent,
      DataGridFilterComponent,
      ErrorComponent,
      SiteHeaderComponent,
      SiteFooterComponent,
      DocumentListComponent,
      DocumentSingleComponent,
      SiteBreadcrumbsComponent,
      SiteFileuploadComponent,
      DateDeclensionPipe,
      TextHighlightPipe,
      StripHtmlTagsPipe,
      AdminFooterComponent
    ],
    imports: [
      RouterModule,
      CommonModule,
      TranslateModule,
      FormsModule,
      NgbModule,
      ReactiveFormsModule,
      SlickCarouselModule,
      MatProgressBarModule,
      MatDatepickerModule,
      MatInputModule,
      NgbCollapseModule,
      NgbDropdownModule,
      NgbAlertModule,
      MatSelectModule,
        // DeviceDetectorModule.forRoot()
    ],
  declarations: [
      SiteFooterComponent,
      NavbarComponent,
      SidebarComponent,
      CustomizerComponent,
      ToggleFullscreenDirective,
      UserHintComponent,
      DataLoaderComponent,
      NoSanitizePipe,
      PaginatorComponent,
      DataGridComponent,
      DataGridFilterComponent,
      ErrorComponent,
      SiteHeaderComponent,
      DocumentListComponent,
      DocumentSingleComponent,
      SiteVpSelectorComponent,
      SiteBreadcrumbsComponent,
      PermissionHideDirective,
      SiteFileuploadComponent,
      DateDeclensionPipe,
      TextHighlightPipe,
      StripHtmlTagsPipe,
      AdminFooterComponent
  ]
})
export class SharedModule { }
